module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/modules/_fails.js